export default __webpack_public_path__ + "static/media/404_animation.922c7839.gif";